
export const version = (state = null, action) => {
  switch (action.type) {
    case 'set_service_version': {
      return action.version;
    }
    default:
      return state;
  }
};
